import { render, staticRenderFns } from "./shops-sellers-list.vue?vue&type=template&id=05b0711c&scoped=true&"
import script from "./shops-sellers-list.vue?vue&type=script&lang=js&"
export * from "./shops-sellers-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b0711c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLazy } from 'vuetify/lib/components/VLazy';
import { VMain } from 'vuetify/lib/components/VMain';
installComponents(component, {VCard,VExpansionPanel,VExpansionPanelHeader,VExpansionPanels,VIcon,VLazy,VMain})
